import { ReactNode } from 'react';

import { Constants } from '../../constants/auth';
import { AvaliaHubLogo } from '../Brand';
import {
  BrandBottom,
  BrandFooter,
  BrandPanel,
  BrandTagline,
  BrandTop,
  BrandWatermark,
  CardHeader,
  CardSubtitle,
  CardTitle,
  FormPanel,
  Screen,
  TenantLogo,
} from './styles';

export {
  AuthCard,
  CardFooter,
  Field,
  GhostLink,
  Input,
  LoadingBox,
  SubmitButton,
} from './styles';

interface AuthShellProps {
  children: ReactNode;
}

/**
 * Two-panel layout for the unauthenticated screens. The left panel is the
 * AvaliaHub brand (product identity, the same for every tenant); the right
 * panel is the `<main>` landmark that hosts the card passed as children.
 */
export function AuthShell({ children }: AuthShellProps): JSX.Element {
  return (
    <Screen>
      <BrandPanel>
        <BrandTop>
          <AvaliaHubLogo
            variant="lockup"
            tone="onDark"
            height={40}
            title={Constants.brandName}
          />
        </BrandTop>
        <BrandBottom>
          <BrandTagline>{Constants.tagline}</BrandTagline>
          <BrandFooter>
            {Constants.copyright(new Date().getFullYear())}
          </BrandFooter>
        </BrandBottom>
        <BrandWatermark aria-hidden="true">
          <AvaliaHubLogo variant="mark" height={560} />
        </BrandWatermark>
      </BrandPanel>
      <FormPanel>{children}</FormPanel>
    </Screen>
  );
}

interface AuthCardHeaderProps {
  title: string;
  subtitle?: string;
  /** Tenant logo (bank/company) shown above the title when the tenant has one. */
  tenantLogo?: string;
}

export function AuthCardHeader({
  title,
  subtitle,
  tenantLogo,
}: AuthCardHeaderProps): JSX.Element {
  return (
    <CardHeader>
      {tenantLogo && <TenantLogo src={tenantLogo} alt="" />}
      <CardTitle component="h1">{title}</CardTitle>
      {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
    </CardHeader>
  );
}
